/**
 * Normalizes inline HTML (text + <br><br>) into block-level <p>-wrapped
 * paragraphs in a schedule's introduction fields (content and note).
 * This ensures the published version (which may use older <br>-based
 * formatting) renders identically to the draft (which uses <p>-wrapped
 * paragraphs from the current editor).
 */
export function normalizeScheduleHtml(schedule) {
    if (!schedule) return schedule
    const intro = schedule.intro
        ? {
              ...schedule.intro,
              content: normalizeFieldToBlocks(schedule.intro.content),
              note: normalizeFieldToBlocks(schedule.intro.note),
          }
        : schedule.intro
    return { ...schedule, intro }
}

const BLOCK_TAGS = new Set(["OL", "UL", "TABLE", "BLOCKQUOTE", "DIV", "H1", "H2", "H3", "H4", "H5", "H6"])

function normalizeFieldToBlocks(html) {
    if (!html || /^\s*<(p|div|ol|ul|table|blockquote|h[1-6])\b/i.test(html)) return html

    const container = document.createElement("div")
    container.innerHTML = html

    const output = []
    let inlineBuf = []
    let brCount = 0
    let afterBlock = false

    for (const node of [...container.childNodes]) {
        if (node.nodeType === 1 && node.tagName === "BR") {
            brCount++
            if (brCount >= 2) {
                flushInline()
                output.push("<br>")
                brCount = 0
                afterBlock = false
            }
            continue
        }
        if (node.nodeType === 1 && BLOCK_TAGS.has(node.tagName)) {
            flushInline()
            if (brCount === 1) output.push("<br>")
            brCount = 0
            output.push(node.outerHTML)
            afterBlock = true
            continue
        }
        if (brCount === 1) {
            if (afterBlock) {
                output.push("<br>")
            } else {
                inlineBuf.push(document.createElement("br"))
            }
        }
        brCount = 0
        afterBlock = false
        inlineBuf.push(node)
    }
    flushInline()
    return output.join("")

    function flushInline() {
        if (!inlineBuf.length) return
        const hasContent = inlineBuf.some((n) => (n.nodeType === 3 ? n.textContent.trim() : n.tagName !== "BR"))
        if (hasContent) {
            const p = document.createElement("p")
            inlineBuf.forEach((n) => p.appendChild(n.cloneNode(true)))
            while (p.firstChild && p.firstChild.nodeName === "BR") p.firstChild.remove()
            while (p.lastChild && p.lastChild.nodeName === "BR") p.lastChild.remove()
            if (p.innerHTML.trim()) output.push(p.outerHTML)
        }
        inlineBuf = []
    }
}
